import styled from "styled-components"

export const Wrapper = styled.div`
  background: ${p => p.theme.colors.white};
  border-radius: 0.6rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  svg {
    height: 2.5rem;
    margin-right: 2rem;
  }
`
export const Label = styled.label`
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-bottom: 0.3rem;
`

export const Error = styled.div`
color: ${p => p.theme.colors.errorText};
`
